export default "__VITE_ASSET__8ecaeceb__"